export default "__VITE_ASSET__269ec64e__"